import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, take, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  httpClient = inject(HttpClient);
  router = inject(Router);
  baseUrl = 'https://api.tridimo.de/api';
  userData: any;
  storedData: any;
  apiUrl = environment.apiUrl;
  testUrl = 'https://test.api.tridimo.de/api/';
  ProductionUrl = 'https://api.tridimo.de/api/';
  private isLoggingOut = false;

  constructor(private http: HttpClient) {}

  login(data: any) {
    console.log('Login via', this.apiUrl);

    return this.httpClient
      .post(`${this.apiUrl}auth/login`, data, {
        withCredentials:
          this.apiUrl === this.testUrl || this.apiUrl === this.ProductionUrl,
      })
      .pipe(
        tap((result) => {
          localStorage.setItem('authUser', JSON.stringify(result));
        }),
      );
  }

  logout() {
    //if (this.isLoggingOut || !isPlatformBrowser(this.platformId)) return;
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    const token = localStorage.getItem('authToken');

    this.http
      .post(`${this.apiUrl}auth/logout`, {}, this.getAuthOptions())
      .pipe(take(1))
      .subscribe({
        next: () => this.localLogout(),
        error: () => this.localLogout(),
      });

    if (!document.cookie || !token) {
      this.localLogout();
    }
  }

  /**
   * Löscht lokale Session- und Benutzerdaten.
   * Danach wird der Benutzer abhängig von der Umgebung
   * zur passenden Login-Seite weitergeleitet.
   */
  localLogout() {
    sessionStorage.clear();
    //localStorage.clear();

    localStorage.removeItem('authUser');
    localStorage.removeItem('role');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('details');
    localStorage.removeItem('calculateTraveltime');

    if (this.apiUrl === this.ProductionUrl) {
      //window.location.replace('https://auth.tridimo.de/login');
      const redirect = encodeURIComponent(window.location.href);
      window.location.replace(
        `https://auth.tridimo.de/login?redirect_url=${redirect}`,
      );
    } else if (this.apiUrl === this.testUrl) {
      //window.location.replace('https://test.auth.tridimo.de/login');
      const redirect = encodeURIComponent(window.location.href);
      window.location.replace(
        `https://test.auth.tridimo.de/login?redirect_url=${redirect}`,
      );
    }
    // else {
    //   window.location.replace('https://dev.auth.tridimo.de/login');
    // }
  }

  isLoggedIn() {
    return localStorage.getItem('authUser') !== null;
  }

  public checkSession(): Observable<any> {
    return this.http
      .get(`${this.apiUrl}user/details`, this.getAuthOptions())
      .pipe(
        tap((response: any) => {
          localStorage.setItem('details', JSON.stringify(response));
        }),

        catchError((error) => of(error)),
      );
  }

  private getAuthOptions(): {
    headers?: HttpHeaders;
    withCredentials?: boolean;
  } {
    const useTokenAuth = environment.useTokenAuth;
    const storedData = localStorage.getItem('authUser');
    let token = '';
    let exp = '';

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        token = parsedData.token;
        exp = parsedData.exp;
        this.checkToken(exp);
      } catch (e) {
        this.logout();
      }
    } else {
      this.logout();
    }

    if (useTokenAuth) {
      return {
        headers: new HttpHeaders({
          Authorization: `${token}`,
          'Content-Type': 'application/json',
        }),
      };
    } else {
      return {
        withCredentials: true,
      };
    }
  }

  checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime - expirationTime > 3600000) {
        this.logout();
      }
    } catch (e) {
      this.logout();
    }
  }
}
